//GeneratorFlag:[NoChange]
import BlogCategory from './blog-category';

export default {BlogCategory}
export{BlogCategory}